export default "__VITE_ASSET__navJxUkm__"